/** Existing Query mutation behavior is unchanged; the shared recorder observes only its declared operation. */
import { useMutation, type UseMutationOptions, type MutationFunction } from '@tanstack/react-query'
import type { ShopifyAppBridge } from '../shopifyApiFetch'
import { trackShopifyAction, type ShopifyUiActionId } from '../shopifyUiTracking'

export function useShopifyTrackedMutation<Data, Variables = void, MutationContext = unknown>(
  shopify: ShopifyAppBridge,
  action: ShopifyUiActionId,
  options: UseMutationOptions<Data, Error, Variables, MutationContext> & {
    mutationFn: MutationFunction<Data, Variables>
  },
) {
  return useMutation({
    ...options,
    mutationFn: (variables, context) =>
      trackShopifyAction(shopify, action, () => options.mutationFn(variables, context)),
  })
}
